module.exports = __webpack_public_path__ + "img/touch_screen.58a643da.png";